import { useQuery } from '@tanstack/react-query';

import { getCurrentLocation } from '../contest.service.api';

const useCurrentLocation = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) =>
  // eslint-disable-next-line local-rules/require-query-stale-time
  useQuery({
    queryKey: ['locations', 'current'],
    queryFn: getCurrentLocation,
    enabled,
  });

export default useCurrentLocation;
